import React, { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import "./customer.css";
import Hexapi from "../../utility/HexAPI/Hexapi";
import HexTextInput from "../../utility/HexInput/HexTextInput";
import HexSelect from "../../utility/HexInput/HexSelect";
import countrydata from "../../utility/countrycode.json";

import { getPhoneErrorMessage, getPhoneMaxLength, validatePhoneNumber } from "../../utility/phoneValidation";
import { decodeUrl } from "./decodeUrl"
import { validateEmail, validateGST } from "./validations";

const INITIAL_FORM = {
    Marketedby: "",
    remark: "",
    companyname: "",
    companysize: "",
    contactperson: "",
    contactnumber: "",
    registercontactnumber: "",
    email: "",
    designation: "",
    officeaddress: "",
    leadsourceid: "",
    subleadsource: "",
    priority: "",
    Leadtypes: "",
    gstno: "",
    countrycodecontactperson: "+91",
    countrycodetrackhr: "+91",
};



export default function CustomerEnquiryform() {
    const [form, setForm] = useState(INITIAL_FORM);
    const [productData, setProductData] = useState([]);
    const [productinterestdata, setProductInterestData] = useState("");
    const [LeadSource, setLeadSource] = useState([]);
    const [SubLeadSource, setSubLeadSource] = useState([]);
    const [AgentList, setAgentList] = useState([]);
    const [ProductID, setProductID] = useState([]);

    const showname = sessionStorage.getItem("Apipathurl");

    

    useEffect(() => {
        Hexapi({
            query: `[dbo].[CRM_Proc_CustomerEnquiry_FormGetData]`,
            queryArr: [],
        })
            .then((resp) => {
                const initialProductData = (resp.product || []).map((item) => ({
                    productid: item.productid,
                    productname: item.product,
                    checked: false,
                    qty: "",
                    rate: "",
                    total: 0,
                }));
console.log(resp,"resp")
                setProductID(resp.product || []);
                setLeadSource(resp.leadsource || []);
                setAgentList(resp.agent || []);
                setProductData(initialProductData);
            })
            .catch(console.error);

        decodeUrl(window.location.href).then((res) => {
            console.log(res, "res");
            if (res?.agentID);
            setForm((prev) => ({ ...prev, Marketedby: res.agentID }));
        });
    }, []);

    
    const setField = useCallback(
        (field) => (value) => setForm((prev) => ({ ...prev, [field]: value })),
        [],
    );

    
    const fetchSubLeadSource = useCallback(async (leadsourceid) => {
        if (!leadsourceid) {
            setSubLeadSource([]);
            setForm((p) => ({ ...p, subleadsource: "" }));
            return;
        }
        try {
            const resp = await Hexapi({
                query: `[dbo].[CRM_Proc_LeadSource_OnChange] @LeadSourceID='{0}'`,
                queryArr: [leadsourceid],
            });
        
            setSubLeadSource(resp.subleadsource || []);
        } catch (err) {
            console.error("error fetching sublead sources", err);
        }
    }, []);


    useEffect(() => {
        if (form.leadsourceid) {
            fetchSubLeadSource(form.leadsourceid);
        }
    }, [form.leadsourceid, fetchSubLeadSource]);

    const handleLeadSourceChange = useCallback(
        (value) => {
            setForm((prev) => ({ ...prev, leadsourceid: value, subleadsource: "" }));
            fetchSubLeadSource(value);
        },
        [fetchSubLeadSource],
    );

    
    const handleContactCountryCodeChange = useCallback((value) => {
        setForm((prev) => ({
            ...prev,
            countrycodecontactperson: value,
            contactnumber: "",
        }));
    }, []);

    const handleRegisteredCountryCodeChange = useCallback((value) => {
        setForm((prev) => ({
            ...prev,
            countrycodetrackhr: value,
            registercontactnumber: "",
        }));
    }, []);

    // ─── Product handlers ────────────────────────────────────────────────────────

    const handleCheckBox = useCallback((e, index) => {
        const checked = e.target.checked;
        setProductData((prev) => {
            const updated = prev.map((item, i) =>
                i === index ? { ...item, checked } : item,
            );
            setProductInterestData(
                updated
                    .filter((p) => p.checked)
                    .map((p) => p.productid)
                    .join(","),
            );
            return updated;
        });
    }, []);

    // ─── Validation ──────────────────────────────────────────────────────────────

    const validateForm = () => {
        const s = form;
        if (!s.Marketedby) return "Marketed by not selected.";
        if (!s.companyname) return "Company Name not filled.";
        if (!s.companysize || s.companysize ==0) return "Company Size not filled.";
        if (!s.contactperson) return "Contact Person not filled.";
        if (!s.countrycodecontactperson)
            return "Contact Number Country Code is required.";
        if (!s.contactnumber) return "Contact number not filled.";
        if (!validatePhoneNumber(s.contactnumber, s.countrycodecontactperson))
            return getPhoneErrorMessage(
                "Contact Number",
                s.countrycodecontactperson,
            );
        if (!s.countrycodetrackhr)
            return "Registered Contact Number Country Code is required.";
        if (!s.leadsourceid) return "Lead Source not selected.";
        if (!s.registercontactnumber)
            return "Registered Contact Number not filled.";
        if (
            !validatePhoneNumber(s.registercontactnumber, s.countrycodetrackhr)
        )
            return getPhoneErrorMessage(
                "Registered Contact Number",
                s.countrycodetrackhr,
            );
        if (!productData.some((p) => p.checked))
            return "At least one product is required.";
        if (!s.Leadtypes) return "Lead Type is required.";
        if (!s.priority) return "Priority is required.";
        if (s.email && !validateEmail(s.email)) return "Invalid email address.";
        if (s.gstno && !validateGST(s.gstno))
            return "Invalid GST Identification Number.";
        return null;
    };

    // ─── Query builder ───────────────────────────────────────────────────────────

    const buildQuery = (forceInsert = false) => {
        const s = form;
        let query = `[dbo].[CRM_Proc_NewLead_SubmitV5]
  @CompanyName='{0}', @CustomerName='{1}', @ContactNumber='{2}',
  @RegisteredContactNumber='{3}', @officeAddress='{4}', @EmailID='{5}',
  @Designation='{6}', @CompanySize='{7}', @AgentID='{8}',
  @ProductInterestIDs='{9}', @LeadType='{10}', @Priority='{11}',
  @LeadSourceID='{12}', @Remarks='{13}', @GSTNumber='{14}',
  @ContactNumberCountryCode='{15}', @RegisteredContactNumberCountryCode='{16}', @SubLeadSource='{17}'`;

        const queryArr = [
            s.companyname,
            s.contactperson,
            s.contactnumber,
            s.registercontactnumber,
            s.officeaddress,
            s.email,
            s.designation,
            s.companysize,
            s.Marketedby,
            productinterestdata,
            s.Leadtypes,
            s.priority,
            s.leadsourceid,
            s.remark,
            s.gstno,
            s.countrycodecontactperson,
            s.countrycodetrackhr,
            s.subleadsource,
        ];

        if (forceInsert) {
            query += `, @Forceinsert='{18}'`;
            queryArr.push(1);
        }

        return { query, queryArr,Marketedby:s.Marketedby };
    };

    // ─── Submit ──────────────────────────────────────────────────────────────────

    const submitToApi = async (forceInsert = false) => {
        const { query, queryArr,Marketedby } = buildQuery(forceInsert);
        console.log(queryArr);
        const resp = await Hexapi({ query, queryArr });
        console.log(resp, "respsss");
        if (resp.newlead[0].command == 1) {
            Swal.fire({
                title: "Thanks For Your Response",
                text: `Your CustomerID is ${resp.newlead[0].customerid}`,
            }).then((r) => {
                if (r.isConfirmed) {
                    setForm({
  Marketedby: Marketedby,
countrycodecontactperson: "+91",
    countrycodetrackhr: "+91",
});
                    setProductData([]);
                    setProductInterestData("");
                    setLeadSource([]);
                    setSubLeadSource([]);
                    setAgentList([]);
                    setProductID([]);
                }
            });
        } else if (resp.newlead[0].command == -1 && !forceInsert) {
            Swal.fire({
                title: "Duplicate Entry",
                text: "A record with this information already exists. Do you want to proceed?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Submit",
                cancelButtonText: "Cancel",
            }).then(async (r) => {
                if (r.isConfirmed) await submitToApi(true);
            });
        } else {
            Swal.fire({ text: resp.newlead[0].msg });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const error = validateForm();
        if (error) {
            Swal.fire({ text: error });
            return;
        }
        try {
            await submitToApi(false);
        } catch (err) {
            console.error(err);
        }
    };

    const labelClass = "text-xs font-bold text-slate-500 uppercase tracking-wider";

    return (
        <form onSubmit={handleSubmit}>
            <main className="flex-grow overflow-y-auto p-8 no-scrollbar bg-surface" style={{height:"93vh", overflow:"auto", paddingBottom:"10vh"}}>
                <div className="max-w-7xl mx-auto space-y-6">
                
                    <div className="flex items-center justify-between bg-white p-4 rounded-lg border border-slate-200 shadow-sm">
                        <div className="flex items-center gap-6">
            
                            <HexSelect
                                label="Marketed by"
                                required
                                disabled
                                value={Number(form.Marketedby)}
                                onChange={setField("Marketedby")}
                                variant="borderless"
                                className="!w-40"
                                options={AgentList.map((s) => ({
                                    value: s.agentid,
                                    label: s.agentname,
                                }))}
                                wrapperClassName="flex flex-col gap-1"
                            />
                        </div>

                        <div className="submit-btn-wrapper">
  <button type="submit" className="submit-btn">
    SUBMIT
  </button>
</div>
                    </div>

                    
                    <section className="bg-white p-8 rounded-lg border border-slate-200 shadow-sm">
                        <div className="mb-8 flex items-center gap-4">
                            <h2 className="text-lg font-bold text-slate-800 shrink-0">
                                Customer Details
                            </h2>
                            <div className="h-px w-full bg-slate-100" />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-6">
                            <HexTextInput
                                label="Company Name"
                                placeholder="Enter Company Name"
                                required
                                onChange={setField("companyname")}
                                value={form.companyname}
                            />

                            <HexTextInput
                                label="Company Size"
                                placeholder="Enter Company Size"
                                required
                                type="number"
                                maxLength={5}
                                showCount
                                onChange={setField("companysize")}
                                value={form.companysize}
                            />

                            <HexTextInput
                                label="Contact Person"
                                placeholder="Enter Contact Person"
                                required
                                onChange={setField("contactperson")}
                                value={form.contactperson}
                            />

                            <HexTextInput
                                label="Designation"
                                placeholder="Enter Designation"
                                onChange={setField("designation")}
                                value={form.designation}
                            />

                            <HexTextInput
                                label="Office Address"
                                placeholder="Enter Office Address"
                                onChange={setField("officeaddress")}
                                value={form.officeaddress}
                            />

                            <HexSelect
                                label="Lead Source"
                                required
                                value={form.leadsourceid}
                                onChange={handleLeadSourceChange}
                                showSearch
                                options={LeadSource.map((s) => ({
                                    value: s.leadsourceid,
                                    label: s.leadsource,
                                }))}
                            />

                            <HexSelect
                                label="Sub Lead Source"
                                creatable
                                allowClear
                                disabled={!form.leadsourceid}
                                value={form.subleadsource}
                                onChange={setField("subleadsource")}
                                placeholder="---Select or type---"
                                options={SubLeadSource.map((s) => ({
                                    value: s.subleadsource,
                                    label: s.subleadsource,
                                }))}
                            />

                            <HexTextInput
                                label="GST No."
                                placeholder="Enter GST Number"
                                maxLength={15}
                                showCount
                                onChange={(val) =>
                                    setForm((p) => ({ ...p, gstno: val.toUpperCase() }))
                                }
                                value={form.gstno}
                            />

                            <HexTextInput
                                label="Email ID"
                                placeholder="Enter Email ID"
                                type="email"
                                onChange={setField("email")}
                                value={form.email}
                            />

                            <HexSelect
                                label="Country Code"
                                required
                                showSearch
                                value={form.countrycodecontactperson}
                                onChange={handleContactCountryCodeChange}
                                options={countrydata.map((item) => ({
                                    value: item.dial_code,
                                    label: `${item.dial_code} ${item.name}`,
                                }))}
                            />

                            <HexTextInput
                                label="Contact Number"
                                placeholder="Enter Contact Number"
                                required
                                numericOnly
                                maxLength={getPhoneMaxLength(form.countrycodecontactperson)}
                                showCount
                                onChange={setField("contactnumber")}
                                value={form.contactnumber}
                            />

                            <HexSelect
                                label="Reg. Country Code"
                                showSearch
                                value={form.countrycodetrackhr}
                                onChange={handleRegisteredCountryCodeChange}
                                options={countrydata.map((item) => ({
                                    value: item.dial_code,
                                    label: `${item.dial_code} ${item.name}`,
                                }))}
                            />

                            <HexTextInput
                                label="Reg. Contact Number"
                                placeholder="Enter Registered Contact Number"
                                required
                                numericOnly
                                maxLength={getPhoneMaxLength(form.countrycodetrackhr)}
                                showCount
                                onChange={setField("registercontactnumber")}
                                value={form.registercontactnumber}
                            />
                        </div>
                    </section>

                    {/* Customer Enquiry Section */}
                    <section className="bg-white p-8 rounded-lg border border-slate-200 shadow-sm">
                        <div className="mb-8 flex items-center gap-4">
                            <h2 className="text-lg font-bold text-slate-800 shrink-0">
                                Customer Enquiry
                            </h2>
                            <div className="h-px w-full bg-slate-100" />
                        </div>

                        <div className="mb-8">
                            <h3 className="text-sm font-bold text-slate-800 mb-6 flex items-center gap-2">
                                Product Interest <span className="text-red-500">*</span>
                            </h3>
                            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-y-6 gap-x-4">
                                {productData.map((data, index) => (
                                    <label
                                        key={data.productid}
                                        className="flex items-center gap-2 cursor-pointer text-sm text-slate-700"
                                    >
                                        <input
                                            type="checkbox"
                                            name={data.productname}
                                            value={data.productid}
                                            checked={data.checked || false}
                                            onChange={(e) => handleCheckBox(e, index)}
                                            className="h-4 w-4 accent-amber-400"
                                        />
                                        {data.productname}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <HexSelect
                                label="Lead Type"
                                required
                                value={form.Leadtypes}
                                onChange={setField("Leadtypes")}
                                options={["Very Hot", "Hot", "Cold", "Very Cold"].map((v) => ({
                                    value: v,
                                    label: v,
                                }))}
                            />

                            <div className="flex flex-col gap-1.5">
                                <label className={labelClass}>
                                    Priority <span className="text-red-500">*</span>
                                </label>
                                <div className="flex gap-4">
                                    {["High", "Medium", "Low"].map((level) => (
                                        <label className="flex-1" key={level}>
                                            <input
                                                type="radio"
                                                name="priority"
                                                value={level}
                                                checked={form.priority === level}
                                                onChange={(e) =>
                                                    setField("priority")(e.target.value)
                                                }
                                                className="hidden peer"
                                            />
                                            <div className="text-center py-2.5 border border-slate-200 rounded-lg text-sm text-slate-500 cursor-pointer hover:bg-slate-50 peer-checked:border-amber-400 peer-checked:bg-amber-50 peer-checked:text-amber-700 font-bold transition-all">
                                                {level}
                                            </div>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <HexTextInput
                                label="Remarks"
                                placeholder="Enter remarks"
                                onChange={setField("remark")}
                                value={form.remark}
                                wrapperClassName="md:col-span-2"
                            />
                        </div>
                    </section>
                </div>
            </main>
        </form>
    );
}
